import React, { PureComponent } from 'react';
import './DataViz.css';
import PropTypes from 'prop-types';
import { Charts } from './Charts/Charts';
import { translate } from '../../utils/translations';
import { GRAPH } from '../../utils/globals';

export class DataViz extends PureComponent {
    state = {
        marginBottom: '0',
        isMounted: false,
    };

    static propTypes = {
        day: PropTypes.number,
        estCel: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.string,
                valor: PropTypes.number,
            })
        ),
        language: PropTypes.string,
        location: PropTypes.string,
        mainChart: PropTypes.string,
        precAcu: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.string,
                valor: PropTypes.number,
            })
        ),
        rerenderChart: PropTypes.bool,
        secondaryChart: PropTypes.bool,
        temp: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.string,
                valor: PropTypes.number,
            })
        ),
        tempFormat: PropTypes.string,
        ventDir: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.string,
                valor: PropTypes.number,
            })
        ),
        ventVelo: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.string,
                valor: PropTypes.number,
            })
        ),
        windSpeedFormat: PropTypes.string,
    };

    render() {
        const {
            day,
            estCel,
            language,
            location,
            mainChart,
            precAcu,
            rerenderChart,
            secondaryChart,
            temp,
            tempFormat,
            ventDir,
            ventVelo,
            windSpeedFormat,
        } = this.props;

        return (
            <div className="wrapper-data-48h mc-widget-dataviz">
                {/* Labels */}
                <div className="wrapper-data-48h__labels mc-widget-dataviz__labels">
                    <div className="mc-widget-dataviz__label-hora">
                        <h3>{translate(language, 'municipal48h_hora')}</h3>
                    </div>
                    <div
                        className="mc-widget-dataviz__label-cel-temp"
                        style={{ bottom: `${this.state.marginBottom}px` }}
                    >
                        <h3>
                            {mainChart === 'estCel'
                                ? translate(language, 'municipal48h_cel')
                                : translate(language, 'municipal48h_dir_vent')}
                        </h3>
                        <h3>
                            {mainChart === 'estCel'
                                ? `${translate(
                                      language,
                                      'municipal48h_temp'
                                  )}(${tempFormat.replace(' º', 'º')})`
                                : `${translate(
                                      language,
                                      'municipal48h_vel_vent'
                                  )} ${windSpeedFormat}`}
                        </h3>
                    </div>

                    <div className="mc-widget-dataviz__label-prec">
                        <h3>
                            <span>
                                {translate(language, 'municipal48h_prec')} (mm)
                            </span>
                        </h3>
                    </div>
                </div>
                {/* Data */}
                <div className="wrapper-data-48h__data mc-widget-dataviz__data">
                    <Charts
                        temp={temp}
                        estCel={estCel}
                        precAcu={precAcu}
                        ventVelo={ventVelo}
                        ventDir={ventDir}
                        mainChart={mainChart}
                        secondaryChart={secondaryChart}
                        figureMargin={this.figureMainChartLabelMargin}
                        rerenderChart={rerenderChart}
                        day={day}
                        location={location}
                        isDatavizMounted={this.state.isMounted}
                        windSpeedFormat={windSpeedFormat}
                    />
                </div>
            </div>
        );
    }

    figureMainChartLabelMargin = (minValue, maxValue, lineArray) => {
        const range = maxValue - minValue;
        const heightY = GRAPH.height;
        const heightOfLabel = 28;
        const minMarginBottom = 18;

        // Get first not null value
        lineArray = lineArray.filter(value => value !== null);
        const firstValue = lineArray.length > 0 ? lineArray[0] : null;

        let marginBottom =
            heightY * ((firstValue - minValue) / range) - heightOfLabel / 2;

        marginBottom = Math.round(
            marginBottom > minMarginBottom ? marginBottom : minMarginBottom
        );

        this.setState({ marginBottom });
    };
}



// WEBPACK FOOTER //
// ./src/partials/DataViz/DataViz.js